export const TINY_MCE_API_KEY = `s5suesqjhar3v9uph0b01d24spff4cqbzkx6o4wuybx8gzbr`;
